<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M7.61035 1.27246L6.86523 5H10.335L11.1348 1H12.665L12.6104 1.27246L11.8652 5H14.25V6.5H11.5645L10.8652 10H13.25V11.5H10.5645L9.86523 15H8.33496L8.38965 14.7275L9.03516 11.5H5.56445L4.86523 15H3.33496L3.38965 14.7275L4.03516 11.5H1.75V10H4.33496L5.03516 6.5H2.75V5H5.33496L6.13477 1H7.66504L7.61035 1.27246ZM5.86426 10H9.33496L10.0352 6.5H6.56445L5.86426 10Z"
    fill="currentColor"
  />
</svg>
